/*
 * @Author: jsZhao
 * @Date: 2018-01-02 14:26:23
 * @Last Modified by: jsZhao
 * @Last Modified time: 2018-01-05 17:59:20
 */

import fetch from '@/utils/fetch'
import {shop_url} from '@/global';

// 查询待审核提现单数目
const findCheck = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/findCheck`,
    method: 'get',
  })
}

// 商家销售排行(前五名)
const topFive = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/topFive`,
    method: 'get'
  })
}

// 查询支付方式
const findMonthPayment = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/findMonthPayment`,
    method: 'get',
  })
}

// 查询月活跃度
const findMonthActive = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/findMonthActive`,
    method: 'get',
  })
}

// 财务界面待提现审核、代交发票、待转账
const findWithdraw = ()=>{
  return fetch({
    url:`${shop_url}/shop/cms/smartPark/user/home/trade/findWithdraw`,
    method: 'get',
  })
}

// 查询提现进程详细信息
const findWithdrawInfo = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/trade/findWithdrawInfo`,
    method: 'get',
  })
}

// 查询用户，商户，企业总数
const allCount = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/all`,
    method: 'get'
  })
}

//查询日交易总数和总交易数
const trade = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/trade`,
    method: 'get'
  })
}

//查询日利润和总利润
const profit =()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/profit`,
    method: 'get',
  })
}

//查询日流水和总流水
const amount = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/amount`,
    method: 'get'
  })
}

//图标查询一周
const weekLine = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/findWeekTrade`,
    method: 'get'
  })
}

//图标查询一个月
const monthLine = ()=>{
  return fetch({
    url: `${shop_url}/shop/cms/smartPark/user/home/super/findMonthTrade`,
    method: 'get'
  })
}

export {
  findCheck,
  topFive,
  findMonthPayment,
  findMonthActive,
  findWithdraw,
  findWithdrawInfo,
  allCount,
  trade,
  profit,
  amount,
  weekLine,
  monthLine,
}




// WEBPACK FOOTER //
// ./src/api/homeApi/index.js